import styled, { css } from 'styled-components';

export default styled.button.attrs({
  type: 'button'
})`
  ${props =>
    !props.isDetails &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      backface-visibility: hidden;

      & > .svg-heart {
        width: 23px;
        height: 23px;
        position: absolute;
        left: 0;
        top: -14px;
        right: 0;
        bottom: 0;
        margin: auto;
        fill: transparent;
        stroke-width: 2px;
        stroke: ${({ theme }) => theme.color.accent};
        transition: fill 0.2s ease-out, stroke 0.2s ease-out, opacity 0.2s ease-in;
      }

      & > .svg-bookmark {
        width: 40px;
        height: 50px;
      }
    `}

  ${props =>
    props.isDetails &&
    css`
      margin-top: 7px;

      & > .svg-heart {
        vertical-align: middle;
        width: 23px;
        height: 23px;
        margin-right: ${({ theme }) => theme.indent.s};
        fill: transparent;
        stroke-width: 2px;
        stroke: ${({ theme }) => theme.color.accent};
        transition: fill 0.2s ease-out, stroke 0.2s ease-out, opacity 0.2s ease-in;

        .l-entity & {
          width: 20px;
          height: 20px;
        }
      }

      & > span {
        vertical-align: middle;
        font-size: 1.4rem;
        font-weight: 500;
        text-transform: uppercase;
        color: #fff;
        transition: color 0.2s ease-out;

        .l-entity & {
          font-size: 1.2rem;
        }
      }
    `}

  &._filled > .svg-heart {
    fill: ${({ theme }) => theme.color.accent};
    stroke: ${({ theme }) => theme.color.accent};
    animation: bounce 0.35s ease-out;
  }

  &._pending {
    pointer-events: none;

    & > .svg-heart {
      opacity: 0.7;
      animation: rotate 0.3s ease-out infinite alternate;
    }

    ${props =>
      props.isDetails &&
      css`
        & > span {
          color: ${({ theme }) => theme.color.textSecondary};
        }
      `}
  }

  @media screen and (min-width: ${({ theme }) => theme.breakPoints.xl.width}) {
    &:hover {
      & > .svg-heart {
        fill: ${({ theme }) => theme.color.accentDark};
        stroke: ${({ theme }) => theme.color.accentDark};
      }

      ${props =>
        props.isDetails &&
        css`
          & > span {
            color: ${({ theme }) => theme.color.textSecondary};
          }
        `}
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    & > span {
      display: none;
    }
  }
`;
